export const getFilterValue = ({ type, filterValues, searchParams, name, backendName, defaultValue }) => {
  if (type === 'string') {
    return searchParams.get(name) || filterValues?.[backendName] || defaultValue || ''
  } else if (type === 'array') {
    return searchParams.getAll(name)?.length
      ? searchParams.getAll(name)
      : filterValues?.[backendName] || defaultValue || []
  } else if (type === 'number') {
    return Number(searchParams.get(name)) || Number(filterValues?.[backendName]) || defaultValue || ''
  }
}

export const transformFilters = (filters, searchParams, filterValues) => {
  return filters.map(filter => ({
    ...filter,
    value: getFilterValue({
      type: filter.type,
      filterValues,
      searchParams,
      name: filter.name,
      backendName: filter.backendName,
      defaultValue: filter.defaultValue,
    }),
  }))
}

export const getFilters = filters => {
  if (filters) {
    return filters.reduce((prev, next) => {
      return { ...prev, [next.name]: next.value }
    }, {})
  }
}

export const getFiltersWithValue = filters => {
  return filters.reduce((prev, next) => {
    if (next.value && next.value !== 'null') {
      return { ...prev, [next.name]: next.value }
    }

    return prev
  }, {})
}

export const getPayload = filters => {
  return filters.reduce((prev, next) => {
    if (next.value && next.value !== 'null') {
      return { ...prev, [next.backendName || next.name]: next.value }
    }

    return prev
  }, {})
}

export const setSearchParamsOnInit = (filters, setSearchParams) => {
  const filtersWithValue = getFiltersWithValue(filters)
  setSearchParams(filtersWithValue)
}
